export default "__VITE_ASSET__129af0fd__"